import { useState } from "react"
import useSafeState from "./common/useSafeState"

export default () => {
    const [ readyed, setReadyed ] = useSafeState(false)

    

    return { readyed, ready: () => setReadyed(true) }
}